import React from "react"
import { useTranslation } from "react-i18next"
import * as Components from "../components/components"
import { getUmsatzsteuerCodesOptions } from "../constants"
import { ZuAbschlag } from "../models/rechnung/rechnungsebene/zuAbschlag"

interface RechnungAbschlagViewProps {
    index: number
    abschlag: ZuAbschlag
    onRemove: (idx: number) => void
    onChange: (idx: number) => (value: any) => void
}

export function RechnungZuschlagView({ index, abschlag, onRemove, onChange }: RechnungAbschlagViewProps) {
    const { t } = useTranslation()
    const umsatzsteuerCodesOptions = getUmsatzsteuerCodesOptions()
    return (
        <div className="zuschlaege">
            <Components.FormGroup label={t("rechnung.rechnungZuschlaege.nachlassNetto.label")}>
                <Components.NumberEdit
                    onChange={(v) => onChange(index)({ ...abschlag, zuAbschlaege: { ...abschlag.zuAbschlaege, nachlassNetto: v } })}
                    value={abschlag.zuAbschlaege.nachlassNetto ?? null}
                />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.rechnungZuschlaege.grundbetragNetto.label")}>
                <Components.NumberEdit
                    onChange={(v) => onChange(index)({ ...abschlag, zuAbschlaege: { ...abschlag.zuAbschlaege, grundbetragNetto: v } })}
                    value={abschlag.zuAbschlaege.grundbetragNetto ?? null}
                />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.rechnungZuschlaege.prozentsatz.label")}>
                <Components.NumberEdit
                    onChange={(v) => onChange(index)({ ...abschlag, zuAbschlaege: { ...abschlag.zuAbschlaege, prozentsatz: v } })}
                    value={abschlag.zuAbschlaege.prozentsatz ?? null}
                    suffix=" %"
                />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.rechnungZuschlaege.umsatzsteuerkategorie.label")}>
                <Components.MultiSelect
                    placeholder={t("rechnung.rechnungZuschlaege.umsatzsteuerkategorie.placeholder")}
                    onChange={(v) => onChange(index)({ ...abschlag, umsatzsteuerkategorie: v })}
                    value={umsatzsteuerCodesOptions.find((o) => o.value === abschlag.umsatzsteuerkategorie)}
                    options={umsatzsteuerCodesOptions}
                />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.rechnungZuschlaege.umsatzsteuersatz.label")}>
                <Components.NumberEdit
                    onChange={(v) => onChange(index)({ ...abschlag, umsatzsteuersatz: v })}
                    value={abschlag.umsatzsteuersatz ?? null}
                    suffix=" %"
                />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.rechnungZuschlaege.grund.label")}>
                <Components.TextEdit
                    placeholder={t("rechnung.rechnungZuschlaege.grund.placeholder")}
                    onChange={(v) => onChange(index)({ ...abschlag, zuAbschlaege: { ...abschlag.zuAbschlaege, grund: v } })}
                    value={abschlag.zuAbschlaege.grund}
                />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.rechnungZuschlaege.grundCode.label")}>
                <Components.TextEdit
                    placeholder={t("rechnung.rechnungZuschlaege.grundCode.placeholder")}
                    onChange={(v) => onChange(index)({ ...abschlag, zuAbschlaege: { ...abschlag.zuAbschlaege, grundCode: v } })}
                    value={abschlag.zuAbschlaege.grundCode}
                />
            </Components.FormGroup>

            <Components.Row>
                <Components.Col align={Components.Align.RIGHT}>
                    <Components.Button
                        style={Components.ButtonStyle.SECONDARY}
                        label={t("rechnung.rechnungZuschlaege.loeschen")}
                        onClick={() => onRemove(index)}
                    />
                </Components.Col>
            </Components.Row>
        </div>
    )
}
